export default __webpack_public_path__ + "static/favicon-2d2ac7b3cf9c08cbaf746bed4bd9856c.ico";